// Use the matrix encoder already shipped with vue-qr; render its modules as
// vectors instead of a canvas bitmap. Keep the standard four-module quiet zone.
import { QRCodeModel, QRErrorCorrectLevel } from 'vue-qr/src/lib/qrcode'

export function certificateQr(text) {
    const code = new QRCodeModel(-1, QRErrorCorrectLevel.M)
    code.addData(text)
    code.make()
    const count = code.getModuleCount(), quiet = 4, cells = []
    for (let row = 0; row < count; row++) {
        for (let col = 0; col < count; col++) {
            if (code.isDark(row, col)) cells.push(`M${col + quiet} ${row + quiet}h1v1h-1z`)
        }
    }
    return { dimension: count + quiet * 2, path: cells.join(''), quiet }
}
